import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 48px 56px;
  font-family: 'Georgia', serif;
  color: #1f2937;
  line-height: 1.8;

  @media screen and (max-width: 768px) {
    padding: 28px 20px;
  }
`;

const DocTitle = styled.h1`
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 4px;
  color: #111827;
`;

const DocSubtitle = styled.p`
  text-align: center;
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 32px;
`;

const MetaTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 32px;
  font-size: 14px;

  td {
    padding: 6px 12px;
    border: 1px solid #d1d5db;
  }

  td:first-child {
    font-weight: 600;
    background: #f9fafb;
    width: 40%;
  }
`;

const SectionTitle = styled.h2`
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #111827;
  margin-top: 36px;
  margin-bottom: 12px;
  border-bottom: 2px solid #1410DF;
  padding-bottom: 6px;
`;

const ClauseTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: #1410DF;
  margin-top: 20px;
  margin-bottom: 6px;
`;

const P = styled.p`
  font-size: 14px;
  margin-bottom: 10px;
`;

const Ul = styled.ul`
  font-size: 14px;
  margin: 8px 0 12px 24px;

  li {
    margin-bottom: 4px;
  }
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 24px;
  font-size: 14px;
  margin-bottom: 16px;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

const InfoValue = styled.span`
  color: #111827;
`;

const Note = styled.p`
  font-size: 13px;
  color: #6b7280;
  font-style: italic;
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
  text-align: center;
`;

const AnnexTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin-top: 12px;

  th {
    background: #1410DF;
    color: white;
    padding: 10px 12px;
    text-align: left;
    font-weight: 600;
  }

  td {
    padding: 8px 12px;
    border-bottom: 1px solid #e5e7eb;
  }

  tr:nth-child(even) td {
    background: #f9fafb;
  }
`;

const FullAgreement = () => (
  <Wrapper>
    <DocTitle>KUSINA | Acuerdo Comercial de Cooperación</DocTitle>
    <DocSubtitle>Versión 1.0 · Vigencia indefinida</DocSubtitle>

    <MetaTable>
      <tbody>
        <tr><td>Documento</td><td>Acuerdo Comercial de Cooperación</td></tr>
        <tr><td>Versión</td><td>1.0</td></tr>
        <tr><td>Vigencia</td><td>Indefinida</td></tr>
      </tbody>
    </MetaTable>

    <SectionTitle>Datos Legales de Kusina</SectionTitle>
    <InfoGrid>
      <InfoRow><InfoLabel>Razón Social</InfoLabel><InfoValue>KUSINA APP E.I.R.L.</InfoValue></InfoRow>
      <InfoRow><InfoLabel>Nombre Comercial</InfoLabel><InfoValue>KUSINA APP</InfoValue></InfoRow>
      <InfoRow><InfoLabel>RUC</InfoLabel><InfoValue>20613753983</InfoValue></InfoRow>
      <InfoRow><InfoLabel>Tipo</InfoLabel><InfoValue>Empresa Individual de Responsabilidad Limitada</InfoValue></InfoRow>
      <InfoRow><InfoLabel>Domicilio Fiscal</InfoLabel><InfoValue>Av. Javier Prado Este Nro. 560 Int. 1302, San Isidro, Lima, Perú</InfoValue></InfoRow>
      <InfoRow><InfoLabel>Actividad Económica</InfoLabel><InfoValue>Programación Informática (CIIU 6201)</InfoValue></InfoRow>
      <InfoRow><InfoLabel>Correo</InfoLabel><InfoValue>soporte@kusina.site</InfoValue></InfoRow>
      <InfoRow><InfoLabel>Teléfono</InfoLabel><InfoValue>+51 973 834 813</InfoValue></InfoRow>
    </InfoGrid>

    <SectionTitle>Preámbulo</SectionTitle>
    <P>
      El presente acuerdo se celebra entre KUSINA APP E.I.R.L. (en adelante, "Kusina"), plataforma tecnológica
      domiciliada en Perú, y el restaurante o establecimiento de alimentos suscriptor (en adelante, "el Aliado
      Comercial" o "el Restaurante"), dentro del área de cobertura de la plataforma.
    </P>
    <P>Las partes se denominan conjuntamente como "las Partes" e individualmente como "la Parte".</P>

    <SectionTitle>Cláusula Primera: Definiciones</SectionTitle>
    <ClauseTitle>1.1 Plataforma Kusina</ClauseTitle>
    <P>Plataforma tecnológica compuesta por aplicaciones móviles y sistemas web que facilitan la exhibición, comercialización y gestión de pedidos.</P>
    <ClauseTitle>1.2 Kusina P.O.S</ClauseTitle>
    <P>Módulo del sistema de punto de venta para gestión operativa: toma de pedidos, facturación y control de órdenes.</P>
    <ClauseTitle>1.3 Kusina Delivery</ClauseTitle>
    <P>Módulo orientado a consumidores finales para compra y entrega de alimentos.</P>
    <ClauseTitle>1.4 Eater / Usuario</ClauseTitle>
    <P>Persona natural que utiliza la plataforma para adquirir productos alimenticios.</P>
    <ClauseTitle>1.5 Orden / Pedido</ClauseTitle>
    <P>Solicitud de compra realizada por un Eater a través de la plataforma o en el establecimiento.</P>
    <ClauseTitle>1.6 Establecimiento</ClauseTitle>
    <P>Local comercial donde se preparan y/o expenden los productos.</P>
    <ClauseTitle>1.7 Comisión</ClauseTitle>
    <P>Porcentaje sobre el valor de cada orden que el restaurante reconoce a Kusina por el uso de la plataforma.</P>
    <ClauseTitle>1.8 Pooler</ClauseTitle>
    <P>Representante de Kusina encargado de la integración y acompañamiento del Aliado Comercial.</P>

    <SectionTitle>Cláusula Segunda: Objeto del Acuerdo y Naturaleza de la Intermediación</SectionTitle>
    <ClauseTitle>2.1</ClauseTitle>
    <P>Kusina proporciona a los Aliados Comerciales acceso a su plataforma tecnológica para que exhiban, ofrezcan y gestionen la comercialización de sus productos alimenticios frente a los Eaters.</P>
    <ClauseTitle>2.2</ClauseTitle>
    <P>Kusina actúa exclusivamente como intermediario tecnológico entre el Aliado Comercial y los Eaters, facilitando la conexión entre ambos a través de herramientas digitales. En ningún caso Kusina adquiere la condición de productor, fabricante, proveedor, vendedor ni co-contratante en la relación de consumo entre el Aliado Comercial y el Eater. La relación contractual de compraventa de alimentos se perfecciona directa y exclusivamente entre el Aliado Comercial y el Eater.</P>
    <ClauseTitle>2.3</ClauseTitle>
    <P>En virtud de lo señalado en la cláusula 2.2, la obligación de emitir los comprobantes de pago que correspondan por cada transacción de venta —sean boletas de venta electrónicas o facturas— recae única y exclusivamente sobre el Aliado Comercial, en su calidad de contribuyente y parte vendedora, conforme a lo establecido en el Reglamento de Comprobantes de Pago aprobado por Resolución de Superintendencia N.º 007-99/SUNAT y sus modificatorias. Kusina no emite, no está obligada a emitir, ni es responsable de la emisión de comprobantes de pago a los consumidores finales.</P>
    <ClauseTitle>2.4</ClauseTitle>
    <P>El Aliado Comercial hace uso de Kusina P.O.S para gestionar órdenes locales y de plataforma, con acceso a Kusina Delivery para la modalidad de entregas a domicilio.</P>

    <SectionTitle>Cláusula Tercera: Comisiones y Estructura de Cobro</SectionTitle>
    <ClauseTitle>3.1 Modalidades de Retribución</ClauseTitle>
    <P>El Aliado Comercial operará bajo una de las siguientes modalidades, según lo pactado en el Anexo A suscrito al momento de la afiliación:</P>
    <ClauseTitle>3.1.1 Modalidad por Comisión Porcentual</ClauseTitle>
    <P>El Aliado Comercial reconocerá a Kusina una comisión fija del veinte por ciento (20%) sobre el valor total de cada Orden procesada, <strong>impuestos incluidos</strong>, para los siguientes tipos de servicio:</P>
    <Ul>
      <li>Recojo en local (pickup)</li>
      <li>Consumo en local (dine-in)</li>
      <li>Entrega a domicilio (delivery)</li>
    </Ul>
    <ClauseTitle>3.1.2 Modalidad de Compra al Por Mayor</ClauseTitle>
    <P>Kusina adquirirá del Aliado Comercial un volumen determinado de productos a un precio mayorista preferencial, pactado de mutuo acuerdo y registrado en el Anexo A. Kusina comercializará dichos productos al consumidor final al precio de venta al público fijado por el Aliado Comercial. La diferencia entre el precio mayorista y el precio de venta al público constituye la retribución de Kusina por sus servicios de intermediación.</P>
    <ClauseTitle>3.2 Base de Cálculo</ClauseTitle>
    <P>
      En la Modalidad por Comisión Porcentual, la comisión se aplica sobre el precio total cobrado al Eater,
      tal como figura en la plataforma al momento de la orden, incluyendo el Impuesto General a las Ventas (IGV)
      u otros tributos que correspondan. Quedan excluidos de la base de cálculo únicamente el costo de envío
      cobrado directamente al Eater y las propinas voluntarias.
    </P>
    <ClauseTitle>3.3 Obligación de Facturación a Precio de Venta al Público</ClauseTitle>
    <P>
      En ambas modalidades, el Aliado Comercial deberá emitir el comprobante de pago (boleta de venta o factura)
      al consumidor final consignando el precio de venta al público, conforme al Reglamento de Comprobantes de
      Pago (R.S. 007-99/SUNAT). En la Modalidad de Compra al Por Mayor, aun cuando Kusina adquiera los productos
      a un precio mayorista preferencial, el Aliado Comercial emitirá el comprobante al Eater por el precio
      completo de venta al público, dado que la relación de consumo se perfecciona entre el Aliado Comercial y
      el Eater. La diferencia entre ambos precios constituye un descuento comercial cuya carga tributaria ante
      la SUNAT es asumida por Kusina.
    </P>
    <ClauseTitle>3.4</ClauseTitle>
    <P>La modalidad específica y los precios mayoristas aplicables (en caso de la Modalidad de Compra al Por Mayor) se determinan al momento de la afiliación y quedan registrados en el Anexo A del presente acuerdo.</P>
    <ClauseTitle>3.5</ClauseTitle>
    <P>Kusina podrá revisar y ajustar la comisión o los precios mayoristas con un preaviso mínimo de treinta (30) días calendario notificado al Aliado Comercial.</P>

    <SectionTitle>Cláusula Cuarta: Pagos, Liquidación y Facturación del Servicio</SectionTitle>
    <ClauseTitle>4.0 Alcance</ClauseTitle>
    <P>Los períodos de liquidación, cortes de pago y facturación descritos en la presente cláusula aplican exclusivamente a los Aliados Comerciales que operen bajo la <strong>Modalidad por Comisión Porcentual</strong> (Cláusula 3.1.1). Para los Aliados Comerciales que operen bajo la <strong>Modalidad de Compra al Por Mayor</strong> (Cláusula 3.1.2), Kusina realiza el pago al momento de la adquisición de los productos, por lo que no aplica el esquema de liquidación semanal ni la facturación por servicio de intermediación prevista en esta cláusula.</P>
    <ClauseTitle>4.1 Cortes de Liquidación</ClauseTitle>
    <P>Kusina consolida las ventas del Aliado Comercial en dos cortes semanales:</P>
    <Ul>
      <li><strong>Corte 1:</strong> Ventas generadas de lunes a miércoles — el depósito del monto neto se efectúa el viernes de la misma semana.</li>
      <li><strong>Corte 2:</strong> Ventas generadas de jueves a domingo — el depósito del monto neto se efectúa el miércoles de la semana siguiente.</li>
    </Ul>
    <ClauseTitle>4.2 Factura de Kusina por Servicio de Intermediación</ClauseTitle>
    <P>
      Al cierre de cada período de liquidación, KUSINA APP E.I.R.L. emitirá una factura electrónica al Aliado Comercial
      por concepto de <em>«Servicio de Intermediación Tecnológica»</em>, por el monto equivalente a la comisión
      acumulada en dicho período conforme a la Cláusula Tercera. El depósito del monto neto al Aliado Comercial se
      realizará simultáneamente o con posterioridad inmediata a la emisión de dicha factura, deducida la comisión
      correspondiente. El Aliado Comercial no deberá emitir comprobante alguno a Kusina por este concepto.
    </P>
    <ClauseTitle>4.3 Contenido de la Liquidación</ClauseTitle>
    <P>Cada liquidación detallará:</P>
    <Ul>
      <li>Total de órdenes procesadas en el período</li>
      <li>Valor bruto de ventas</li>
      <li>Comisión por servicio de intermediación descontada</li>
      <li>Deducciones por cancelaciones y devoluciones aplicables</li>
      <li>Monto neto a depositar al Aliado Comercial</li>
    </Ul>
    <ClauseTitle>4.4 Plazo de Reclamo</ClauseTitle>
    <P>El Aliado Comercial dispone de cinco (5) días hábiles desde la recepción de la liquidación para formular observaciones. Transcurrido dicho plazo sin pronunciamiento, la liquidación se tendrá por aceptada de forma tácita.</P>
    <ClauseTitle>4.5 Datos Bancarios</ClauseTitle>
    <P>Es responsabilidad exclusiva del Aliado Comercial mantener actualizados sus datos bancarios en la plataforma. Kusina no asume responsabilidad por depósitos realizados en cuentas desactualizadas por negligencia del Aliado.</P>

    <SectionTitle>Cláusula Quinta: Cancelaciones y Devoluciones</SectionTitle>
    <ClauseTitle>5.1 Cancelación Tardía por el Aliado Comercial</ClauseTitle>
    <P>Si el Aliado Comercial cancela una orden confirmada dentro de los cinco (5) minutos previos a la hora de entrega pactada, el personal de Kusina quedará facultado para negociar directamente con el consumidor final la retribución que corresponda. Dicha retribución consistirá, como mínimo, en el reembolso del valor del servicio de delivery de la orden cancelada, el cual será cargado al Aliado Comercial en la liquidación del período.</P>
    <ClauseTitle>5.2 Error en el Pedido</ClauseTitle>
    <P>Si el Aliado Comercial entrega un pedido erróneo, con productos distintos a los solicitados, en cantidades incorrectas o con omisiones, el costo total del producto será asumido íntegramente por el Aliado Comercial. Kusina gestionará con el Eater la reposición o devolución correspondiente, y el monto será descontado de la liquidación del período.</P>
    <ClauseTitle>5.3</ClauseTitle>
    <P>Son cancelaciones atribuibles al restaurante, entre otras:</P>
    <Ul>
      <li>Productos agotados o no disponibles</li>
      <li>Demora excesiva en la preparación</li>
      <li>Productos en mal estado</li>
      <li>Errores en el pedido</li>
      <li>Incumplimiento de estándares de calidad</li>
    </Ul>
    <ClauseTitle>5.4</ClauseTitle>
    <P>Los descuentos por cancelaciones y errores de pedido se aplican en la liquidación semanal inmediatamente siguiente.</P>
    <ClauseTitle>5.5</ClauseTitle>
    <P>Las cancelaciones atribuibles al Eater o causas de fuerza mayor no generan cargo al restaurante.</P>
    <ClauseTitle>5.6</ClauseTitle>
    <P>Kusina proporcionará un registro detallado de cancelaciones, errores de pedido y devoluciones en cada liquidación.</P>

    <SectionTitle>Cláusula Sexta: Obligaciones del Restaurante</SectionTitle>
    <P>El restaurante se obliga a:</P>
    <ClauseTitle>6.1</ClauseTitle>
    <P>Mantener permanentemente actualizado el menú, fotografías, precios, horarios y disponibilidad en la plataforma.</P>
    <ClauseTitle>6.2</ClauseTitle>
    <P>Ser el único y exclusivo responsable ante los Eaters y cualquier tercero por la calidad, composición, estado, condiciones bromatológicas e higiénicas, seguridad, presentación y legalidad de todos sus productos.</P>
    <ClauseTitle>6.3</ClauseTitle>
    <P>Cumplir las normas sanitarias, de seguridad alimentaria y demás regulaciones peruanas aplicables.</P>
    <ClauseTitle>6.4</ClauseTitle>
    <P>Tramitar y atender oportunamente las órdenes recibidas, preparándolas conforme a lo solicitado.</P>
    <ClauseTitle>6.5</ClauseTitle>
    <P>Utilizar Kusina P.O.S adecuadamente, conforme a las instrucciones proporcionadas.</P>
    <ClauseTitle>6.6</ClauseTitle>
    <P>Informar inmediatamente cualquier cambio en su situación legal, tributaria, operativa o comercial.</P>
    <ClauseTitle>6.7</ClauseTitle>
    <P>No ofrecer productos cuya venta esté prohibida o restringida en el Perú.</P>
    <ClauseTitle>6.8</ClauseTitle>
    <P>Contar con todos los permisos, licencias y autorizaciones vigentes requeridos por la normativa peruana.</P>

    <SectionTitle>Cláusula Séptima: Obligaciones de Kusina</SectionTitle>
    <P>Kusina se obliga a:</P>
    <ClauseTitle>7.1</ClauseTitle>
    <P>Poner a disposición la plataforma y el P.O.S en condiciones operativas adecuadas.</P>
    <ClauseTitle>7.2</ClauseTitle>
    <P>Proporcionar capacitación inicial y acompañamiento a través del Pooler asignado.</P>
    <ClauseTitle>7.3</ClauseTitle>
    <P>Realizar los pagos en los plazos y condiciones establecidos en la Cláusula Cuarta.</P>
    <ClauseTitle>7.4</ClauseTitle>
    <P>Brindar soporte técnico para incidencias relacionadas con la plataforma.</P>
    <ClauseTitle>7.5</ClauseTitle>
    <P>Proporcionar acceso a reportes y estadísticas de ventas.</P>
    <ClauseTitle>7.6</ClauseTitle>
    <P>Notificar con anticipación sobre actualizaciones, mantenimientos o cambios que afecten la operación.</P>

    <SectionTitle>Cláusula Octava: Propiedad Intelectual y Uso de Marca</SectionTitle>
    <ClauseTitle>8.1</ClauseTitle>
    <P>Cada parte conserva la titularidad de sus derechos de propiedad intelectual. El presente acuerdo no implica transferencia de tecnología ni de derechos.</P>
    <ClauseTitle>8.2</ClauseTitle>
    <P>El Restaurante autoriza a Kusina a utilizar su nombre comercial, logotipos e imágenes de sus productos para fines de exhibición en la plataforma y en materiales promocionales.</P>
    <ClauseTitle>8.3</ClauseTitle>
    <P>El Restaurante garantiza que las imágenes y contenidos proporcionados no infringen derechos de terceros.</P>

    <SectionTitle>Cláusula Novena: Confidencialidad</SectionTitle>
    <ClauseTitle>9.1</ClauseTitle>
    <P>Las Partes se obligan a mantener en confidencialidad toda información comercial, financiera, operativa y técnica que reciban en el marco del presente acuerdo.</P>
    <ClauseTitle>9.2</ClauseTitle>
    <P>Esta obligación subsiste durante 2 años desde la terminación del acuerdo.</P>
    <ClauseTitle>9.3</ClauseTitle>
    <P>Se exceptúa la información de dominio público, la requerida por ley u orden judicial, o la conocida lícitamente con anterioridad.</P>

    <SectionTitle>Cláusula Décima: Protección de Datos Personales</SectionTitle>
    <ClauseTitle>10.1</ClauseTitle>
    <P>Las Partes cumplen la Ley N.º 29733 de Protección de Datos Personales y la normativa peruana aplicable.</P>
    <ClauseTitle>10.2</ClauseTitle>
    <P>El Restaurante no utilizará los datos de los Eaters para fines distintos a la atención de las órdenes.</P>
    <ClauseTitle>10.3</ClauseTitle>
    <P>Kusina no compartirá datos del restaurante con terceros, salvo que sea necesario para la ejecución del acuerdo o por requerimiento de autoridad competente.</P>

    <SectionTitle>Cláusula Undécima: Responsabilidad, Indemnidad y Responsabilidad Sanitaria</SectionTitle>
    <ClauseTitle>11.1 Responsabilidad General del Aliado Comercial</ClauseTitle>
    <P>El Aliado Comercial es el único y exclusivo responsable frente a los Eaters, las autoridades competentes y cualquier tercero, por todo reclamo, daño, perjuicio, sanción administrativa o acción judicial derivada de la calidad, composición, inocuidad, condiciones bromatológicas, higiénico-sanitarias, seguridad y legalidad de los productos que comercializa a través de la plataforma.</P>
    <ClauseTitle>11.2 Responsabilidad por Enfermedades Transmitidas por Alimentos</ClauseTitle>
    <P>
      De manera específica e irrenunciable, cualquier reclamo, denuncia, proceso administrativo sancionador
      ante DIGESA, SENASA, la Municipalidad competente o el INDECOPI, así como toda acción civil o penal,
      derivada de enfermedades transmitidas por alimentos (ETA), intoxicaciones alimentarias, alergias,
      contaminación microbiológica, química o física, u otros daños a la salud de los consumidores causados
      por el consumo de los productos del Aliado Comercial, serán de exclusiva responsabilidad de este último.
      Kusina, en su condición de intermediario tecnológico que no interviene en la cadena de producción,
      manipulación, almacenamiento ni despacho de alimentos, queda expresa y totalmente excluida de
      responsabilidad civil extracontractual, administrativa y penal en dichos supuestos.
    </P>
    <ClauseTitle>11.3 Obligación de Indemnidad</ClauseTitle>
    <P>El Aliado Comercial se obliga a defender, indemnizar y mantener indemne a KUSINA APP E.I.R.L., sus socios, directivos, empleados y representantes, frente a cualquier pretensión, demanda, multa, penalidad o gasto —incluidos honorarios legales— que se derive de: (i) el incumplimiento de las obligaciones asumidas en el presente acuerdo; (ii) la mala calidad o insalubridad de sus productos; (iii) la falta de permisos o licencias sanitarias; o (iv) cualquier acto u omisión del Aliado Comercial en el ejercicio de su actividad.</P>
    <ClauseTitle>11.4 Limitación de Responsabilidad de Kusina</ClauseTitle>
    <P>Kusina no asume responsabilidad por interrupciones temporales de la plataforma derivadas de mantenimiento programado, actualizaciones del sistema, fallas de terceros proveedores de infraestructura tecnológica, o causas de fuerza mayor o caso fortuito debidamente acreditados.</P>

    <SectionTitle>Cláusula Duodécima: Vigencia y Terminación</SectionTitle>
    <ClauseTitle>12.1</ClauseTitle>
    <P>El acuerdo entra en vigencia desde su suscripción y tiene duración indefinida.</P>
    <ClauseTitle>12.2</ClauseTitle>
    <P>Cualquiera de las Partes puede terminar el acuerdo unilateralmente y sin expresión de causa, con un preaviso mínimo de 15 días.</P>
    <ClauseTitle>12.3</ClauseTitle>
    <P>Kusina puede resolver el acuerdo de forma inmediata y sin preaviso ante:</P>
    <Ul>
      <li>Incumplimiento grave o reiterado de las obligaciones</li>
      <li>Actos que afecten la reputación o imagen de Kusina</li>
      <li>Incumplimiento de normas sanitarias o de seguridad alimentaria</li>
      <li>Fraude, falsificación o conductas ilícitas</li>
    </Ul>
    <ClauseTitle>12.4</ClauseTitle>
    <P>En caso de terminación, Kusina liquidará los montos pendientes dentro de los 15 días hábiles siguientes.</P>

    <SectionTitle>Cláusula Decimotercera: No Exclusividad</SectionTitle>
    <ClauseTitle>13.1</ClauseTitle>
    <P>El acuerdo no confiere exclusividad. El restaurante es libre de comercializar a través de otras plataformas.</P>
    <ClauseTitle>13.2</ClauseTitle>
    <P>Kusina es libre de celebrar acuerdos similares con otros establecimientos en la misma zona geográfica.</P>

    <SectionTitle>Cláusula Decimocuarta: Modificaciones</SectionTitle>
    <ClauseTitle>14.1</ClauseTitle>
    <P>Kusina puede modificar los términos del presente acuerdo notificando al Restaurante con un preaviso mínimo de 30 días.</P>
    <ClauseTitle>14.2</ClauseTitle>
    <P>El uso continuado de la Plataforma por parte del Restaurante después de la entrada en vigencia de las modificaciones constituirá su aceptación tácita.</P>
    <ClauseTitle>14.3</ClauseTitle>
    <P>Si el Restaurante no acepta las modificaciones, podrá terminar el acuerdo conforme a la Cláusula Duodécima.</P>

    <SectionTitle>Cláusula Decimoquinta: Solución de Controversias</SectionTitle>
    <ClauseTitle>15.1</ClauseTitle>
    <P>Las Partes se comprometen a resolver cualquier controversia mediante negociación directa en primera instancia.</P>
    <ClauseTitle>15.2</ClauseTitle>
    <P>Si no se alcanza acuerdo en 15 días hábiles, las Partes podrán someter la controversia a arbitraje de derecho o a la jurisdicción de los juzgados y tribunales competentes.</P>

    <SectionTitle>Cláusula Decimosexta: Ley Aplicable</SectionTitle>
    <P>El presente Acuerdo se rige e interpreta conforme a las leyes de la República del Perú.</P>

    <SectionTitle>Cláusula Decimoséptima: Disposiciones Generales</SectionTitle>
    <ClauseTitle>17.1 Acuerdo Total</ClauseTitle>
    <P>El presente documento constituye el acuerdo íntegro entre las Partes e invalida cualquier acuerdo previo sobre la misma materia.</P>
    <ClauseTitle>17.2 Cesión</ClauseTitle>
    <P>El Restaurante no puede ceder sus derechos y obligaciones sin consentimiento previo y por escrito de Kusina.</P>
    <ClauseTitle>17.3 Independencia de las Partes</ClauseTitle>
    <P>La relación entre las Partes es estrictamente comercial. Nada en el presente Acuerdo podrá interpretarse como la creación de una relación laboral, societaria, de agencia o de representación entre ellas.</P>
    <ClauseTitle>17.4 Nulidad Parcial</ClauseTitle>
    <P>La nulidad de alguna cláusula no afecta la validez de las demás disposiciones del acuerdo.</P>
    <ClauseTitle>17.5 Comunicaciones</ClauseTitle>
    <P>Toda comunicación debe realizarse por escrito (correo electrónico o medio físico) a las direcciones indicadas por las Partes.</P>

    <SectionTitle>Anexo A: Condiciones Comerciales Específicas</SectionTitle>
    <AnnexTable>
      <thead>
        <tr>
          <th>Concepto</th>
          <th>Detalle</th>
        </tr>
      </thead>
      <tbody>
        <tr><td>Razón Social del Restaurante</td><td>Según registro del Aliado</td></tr>
        <tr><td>RUC</td><td>Según registro del Aliado</td></tr>
        <tr><td>Nombre Comercial</td><td>Según registro del Aliado</td></tr>
        <tr><td>Dirección del Establecimiento</td><td>Según registro del Aliado</td></tr>
        <tr><td>Modalidad de Retribución</td><td>Comisión Porcentual o Compra al Por Mayor (según lo pactado)</td></tr>
        <tr><td>Comisión Acordada (si aplica)</td><td>20% fijo sobre el valor de cada orden, impuestos incluidos</td></tr>
        <tr><td>Precio Mayorista (si aplica)</td><td>Precio preferencial pactado por producto — el Aliado emite comprobante al Eater por el precio de venta al público</td></tr>
        <tr><td>Cuenta Bancaria para Depósitos</td><td>Según registro del Aliado</td></tr>
        <tr><td>Días de Pago</td><td>Lunes–Miércoles: depósito el viernes de la misma semana · Jueves–Domingo: depósito el miércoles de la semana siguiente</td></tr>
        <tr><td>Facturación del Servicio</td><td>Kusina emite factura electrónica al Aliado por «Servicio de Intermediación Tecnológica» al cierre de cada período. El Aliado no emite comprobante a Kusina por este concepto.</td></tr>
        <tr><td>Comprobantes al Consumidor Final</td><td>Obligación exclusiva del Aliado Comercial — debe emitir boleta o factura al precio de venta al público, incluso en la Modalidad de Compra al Por Mayor (conforme a R.S. 007-99/SUNAT)</td></tr>
        <tr><td>Horario de Operación en Plataforma</td><td>Según horario del establecimiento</td></tr>
        <tr><td>Fecha de Inicio de Operaciones</td><td>Según fecha de afiliación</td></tr>
      </tbody>
    </AnnexTable>

    <Note>
      El presente documento tiene carácter informativo y describe los términos generales que rigen la relación
      comercial entre Kusina y sus Aliados Comerciales. Para consultas: soporte@kusina.site
    </Note>
  </Wrapper>
);

export default FullAgreement;
